import clsx from 'clsx';
import React from 'react';

import img50 from 'images/pro/50.png';
import imgAmazon from 'images/pro/Amazon.png';
import imgCEDB from 'images/pro/CE_DB.png';
import imgGoogle from 'images/pro/Google.png';
import imgMeta from 'images/pro/Meta.png';
import imgProWeekly from 'images/pro/ProWeekly_Landing.svg';
import imgVC from 'images/pro/VC.png';

const ProMarketingCTAs = ({ shouldOverlapPaywall }: { shouldOverlapPaywall?: boolean }) => (
  <div
    id="pro-marketing-ctas"
    className={clsx('tw-bg-secondary-pink tw-px-16 xs:tw-px-48', {
      '-mt-40 tw-pt-48 tw-pb-32 md:-mt-[120px] md:tw-pt-[152px] md:tw-pb-72': shouldOverlapPaywall,
      'tw-py-32 md:tw-py-72': !shouldOverlapPaywall,
    })}
  >
    <div className="md:tw-max-w-[1024px] tw-mx-auto">
      <p className="tw-font-serif tw-text-headline-4 md:tw-text-headline-2 tw-text-primary-black tw-m-0">
        You{'’'}ll have access to:
      </p>
      <div className="sm:tw-flex tw-justify-between tw-gap-x-[44px] tw-mt-32 tw-pb-48 md:tw-mt-48 md:tw-pb-64 tw-border-0 tw-border-b-3 tw-border-solid tw-border-white">
        <div className="sm:tw-max-w-[458px]">
          <h3 className="tw-font-serif tw-text-headline-5 tw-text-primary-black tw-m-0">
            Org Chart Library
          </h3>
          <p className="tw-text-paragraph tw-font-serif tw-text-black tw-m-0 tw-mt-8">
            Our one-of-a-kind org charts track the thousands of individuals who lead the most
            consequential companies. Use these charts to study your competitors and target
            candidates for recruitment. We add and update org charts monthly.
          </p>
        </div>
        <div className="tw-flex tw-flex-nowrap xs:tw-flex-wrap md:tw-flex-nowrap tw-items-center tw-justify-center tw-gap-x-[44px] sm:tw-max-w-[50%] tw-mt-16 sm:tw-m-0">
          <div className="tw-w-[100px] md:tw-w-[150px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-min-h-[50px]"
              src={imgGoogle}
              alt="Google"
            />
          </div>
          <div className="tw-w-[100px] md:tw-w-[150px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-min-h-[50px]"
              src={imgAmazon}
              alt="Amazon"
            />
          </div>
          <div className="tw-w-[100px] md:tw-w-[150px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-min-h-[50px]"
              src={imgMeta}
              alt="Meta"
            />
          </div>
        </div>
      </div>
      <div className="sm:tw-flex tw-items-center tw-justify-between tw-gap-x-64 tw-py-48 md:tw-py-64 tw-border-0 tw-border-b-3 tw-border-solid tw-border-white">
        <div className="sm:tw-max-w-[458px] sm:tw-order-1">
          <h3 className="tw-font-serif tw-text-headline-5 tw-text-primary-black tw-m-0">
            Proprietary Databases and Surveys
          </h3>
          <p className="tw-text-paragraph tw-font-serif tw-text-black tw-m-0 tw-mt-8">
            We{'’'}ve gathered unique data points on the most salient sectors of tech—and keep our
            resources up to date through hundreds of hours of reporting each month. You
            {'’'}ll have access to the Creator Economy Database, The Information{'’'}s 50 Most
            Promising Startups, VC Diversity Index and more, along with our monthly subscriber
            survey results.
          </p>
        </div>
        <div className="tw-flex tw-flex-nowrap xs:tw-flex-wrap md:tw-flex-nowrap tw-items-center tw-justify-center tw-gap-x-20 md:tw-gap-x-32 sm:tw-max-w-[50%] tw-mt-24 sm:tw-m-0">
          <div className="tw-w-[100px] md:tw-w-[150px]">
            <img
              className="tw-block tw-object-contain tw-w-full"
              src={img50}
              alt="The Information 50"
            />
          </div>
          <div className="tw-w-[100px] md:tw-w-[150px]">
            <img
              className="tw-block tw-object-contain tw-w-full"
              src={imgVC}
              alt="VC Diversity Index"
            />
          </div>
          <div className="tw-w-[100px] md:tw-w-[150px]">
            <img
              className="tw-block tw-object-contain tw-w-full"
              src={imgCEDB}
              alt="Creator Economy Database"
            />
          </div>
        </div>
      </div>
      <div className="sm:tw-flex tw-items-center tw-gap-x-48 tw-pt-48 md:tw-pt-64">
        <div className="sm:tw-max-w-[458px]">
          <h3 className="tw-font-serif tw-text-headline-5 tw-text-primary-black tw-m-0">
            The Information Pro Weekly Wrap
          </h3>
          <p className="tw-text-paragraph tw-font-serif tw-text-black tw-m-0 tw-mt-8">
            We{'’'}ll sort through and analyze the most significant updates to our data each week in
            an exclusive newsletter for Pro subscribers.
          </p>
        </div>
        <div className="tw-w-[350px] sm:tw-w-auto tw-max-w-full tw-mx-auto tw-mt-24 sm:tw-m-0">
          <img className="tw-block tw-object-contain tw-w-full" src={imgProWeekly} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default ProMarketingCTAs;
